import {UpdateFacilityTemplateModel} from "../../utils/types/facility";
import React, {
  createContext,
  useContext,
  FunctionComponent,
  useState,
  PropsWithChildren,
} from "react";

const context = createContext({
  facilityId: undefined,
  fields: undefined,
  toggle: (facilityId?: string, fields?: UpdateFacilityTemplateModel) => {},
});

export const useEditFacilityModalContext = () => useContext(context);

export const EditFacilityModalProvider: FunctionComponent<
  PropsWithChildren<{}>
> = ({children}) => {
  const [facilityId, setFacilityId] = useState<string>();
  const [fields, setFields] = useState<UpdateFacilityTemplateModel>();

  return (
    <context.Provider
      value={{
        fields,
        facilityId,
        toggle: (
          newFacilityId?: string,
          newFields?: UpdateFacilityTemplateModel,
        ) => {
          setFacilityId(newFacilityId);
          setFields(newFields);
        },
      }}
    >
      {children}
    </context.Provider>
  );
};
